/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated';
import { createUnaryMinus } from '../../factoriesAny.js';
export var unaryMinusDependencies = {
  typedDependencies: typedDependencies,
  createUnaryMinus: createUnaryMinus
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesUnaryMinus.generated.js
// module id = 105
// module chunks = 0